<template>
  <div ref="refChart" class="charts"></div>
</template>
<script>
import echarts from "echarts";
import 'echarts-liquidfill';
import { getOption } from "./config.js";
export default {
  props:{
    data:{
      type:Number
    },
    flag:{
      type:Number
    }
  },
  data(){
    return {
      oEchart:null
    }
  },
  mounted(){
    this.setOptions(this.data,this.flag);
  },
  methods:{
    setOptions(data,flag){
      //console.log(data)
      const _this = this;
      _this.oEchart = echarts.init(_this.$refs.refChart);
      _this.oEchart.setOption(getOption(data,flag));
      window.addEventListener('resize', function () {
        _this.oEchart.resize();
      });
      _this.oEchart.resize();
    },

  }
}
</script>
<style lang="scss" scoped>
.charts{
  width: 120px;
  height: 120px;
}
</style>